export const getHoursBetweenTimestamps = (firstTimestamp, secondTimestamp) => {
  const difference = firstTimestamp - secondTimestamp;
  const differenceInHours = difference / 1000 / 60 / 60;
  return Math.abs(Math.round(differenceInHours));
}
